<template>
  <div
    :class="`justify-center leading-[1.7] flex gap-[12px] text-[14px] text-white px-[12px] py-[12px] lg:text-[16px] lg:py-[12px] lg:leading-[1.5] ${data.type}`"
  >
    <span><InfoIcon /></span>
    <div v-html="data.text" />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { ResolvedBannerData } from "./types";
import InfoIcon from "./assets/info.svg?inline";

export default Vue.extend({
  props: {
    data: {
      type: Object as PropType<ResolvedBannerData>,
      required: true,
    },
  },
  components: {
    InfoIcon,
  },
});
</script>

<style scoped>
@tailwind utilities;
@tailwind base;
@tailwind components;

.info-banner {
  @apply bg-[#f6f9fc] text-[#060606] border-y-[1px] border-[#2772db];
}

.warning-banner {
  @apply bg-warning-banner;
}

.alert-banner {
  @apply bg-alert-banner;
}

.dark-banner {
  @apply bg-dark-banner;
}
</style>
